import { useMutation, useQueryClient } from "react-query";

import { roleRequest } from "~/pages/RegistryOfRole/rolesRequest/roleRequest";

export default function useRoleMutation(
  url: string,
  method: string | ((id: string) => string),
  queryKey: string,
) {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, roleData }: { id: string; roleData: any }) => {
      const resolvedMethod = typeof method === "function" ? method(id) : method;
      return roleRequest(url, resolvedMethod, roleData);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey]);
      },
      onError: (error) => {
        console.error("Ошибка мутации:", error);
      },
    },
  );
}
